/* eslint-disable import/default */
/* eslint-disable no-restricted-imports */

import dayjs from "dayjs";
import enGb from "dayjs/locale/en-gb";

import utc from "dayjs/plugin/utc";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(minMax);

enGb.weekStart = 1;
dayjs.locale(((dayjs as any)["en-gb"] = enGb));

// eslint-disable-next-line prettier/prettier
export type { Dayjs } from "dayjs";

export default dayjs;
